/* eslint-disable */
import { CountriesStore } from '../stores/countries';
import { OperatorsStore } from '../stores/operators';
import { RateStore } from '../stores/rate';
import {
    addIncludedList,
    apiMessagesSaveMessagesV2,
    cleanApiMessages,
    cleanCatalogsStore,
    cleanCountriesStore,
    cleanCurrenciesStore,
    cleanIncludedStore,
    cleanOperatorsStore,
    cleanZonesStore,
    getCatalogsRateUnitTypeSelect,
    getCompaniesSelect,
    getCountriesWithZoneList,
    getCurrenciesSelect,
    getIncludeAssignedCompaniesAPI,
    getNetworksSelect,
    getOperatorsSelect,
    getStoreFeatureFlags,
    getUnitById,
    getUnitIdLabel,
    getUnitLabel,
    getZonesSelect,
    removeIncludedList,
    setIncludedAssignedCompaniesAPI,
    setIncludedList,
    updateIncludedList,
} from './';
import { setRatesForcedUpdateTime } from './rates';
import dayjs from 'dayjs';
import { appConfig } from '../settings';
import { IGetApiResponse, IRequestRateDataInfo, apiManager } from '../REST';
import {
    IBodyItemResponse,
    ICountryWithZone,
    IIncludeAssignedCompanyIncludeItemPostAPI,
    IIncludeAssignedCompanyItem,
    IIncludeItemCurrencyAPI,
    IIncludeItemUnitAPI,
    IIncludeNameItemAPI,
    IIncludeRateAttributesAPI,
    IIncludeRateRateListAPI,
    IIncludeTypeAPI,
    IIncludeUnitItemAPI,
    IItemAPI,
    IPatchItem,
    IRateCountryFormInitialValues,
    IRateIncludeItemAPI,
    IRateInfo,
    IRateItemAPI,
    IRateListAPI,
    IRateListRespAPIV22,
    IRateListRespAppliedCompanyAPIV22,
    IRateListRespEntryAPIV2,
    IRateListRespEntryAPIV22,
    IRateListRespEntryV2,
    IRateNetworkItem,
    IRelationshipItem,
    IRequestAPIBody,
    IRequestRelationships,
    IRespSalesRateListAssignedCompany,
    IUseRateForm,
    RareFormTab,
} from '../interfaces';
import {
    equalObjects,
    globalHexId,
    isNewId,
    mapApi2UiField,
    mapUi2ApiField,
    optionalAPIDayjs,
    optionalAPIString,
    sortByName,
    stringOrUndefined2NumOrUndefined,
} from '../instruments';

export function cleanRateStore(): void {
    const StoreInstance = RateStore.getInstance();
    StoreInstance.cleanStore();
}

function setRateInfo(info: IRateInfo): void {
    const StoreInstance = RateStore.getInstance();
    const { rateInfo } = StoreInstance;
    if (!info.id && !!rateInfo.id) {
        info.id = rateInfo.id;
    }
    if (JSON.stringify(info) !== JSON.stringify(rateInfo)) {
        StoreInstance.setRateInfo(info);
    }
}

function setRateNetworksListOriginal(list: IRateNetworkItem[]): void {
    const StoreInstance = RateStore.getInstance();
    StoreInstance.setRateNetworksListOriginal(list);
}
function setRateNetworksList(list: IRateNetworkItem[]): void {
    const StoreInstance = RateStore.getInstance();
    const { rateNetworksList } = StoreInstance;
    if (JSON.stringify(list) !== JSON.stringify(rateNetworksList)) {
        StoreInstance.setRateNetworksList(list);
    }
}

function updateRateAssignedCompany(list: IIncludeAssignedCompanyItem[]): void {
    updateIncludedList('assignedCompanies', list);
}

export function setRateForm(form: IUseRateForm): void {
    const info = { ...form };
    delete info.assignedCompanies;
    setRateInfo(info);
    const assignedCompanies: IIncludeAssignedCompanyItem[] = form.assignedCompanies || [];
    updateRateAssignedCompany(assignedCompanies);
}

function createRateInfo(): void {
    const newRate: IRateInfo = {
        id: globalHexId.getId(),
    };
    setRateInfo(newRate);
}

export function setCountriesRateListOriginal(list: IRateCountryFormInitialValues[] = []): void {
    const StoreInstance = RateStore.getInstance();
    StoreInstance.setCountriesRateListOriginal(list);
}

export function createRateList(defaultList: IRateCountryFormInitialValues[] = []): void {
    const { newResponseFormatCountries } = getStoreFeatureFlags();
    const operatorsSelect = OperatorsStore.getInstance().operatorsSelect;
    const countriesSelect = newResponseFormatCountries
        ? CountriesStore.getInstance().select
        : CountriesStore.getInstance().countriesWithZoneList;
    const list: IRateCountryFormInitialValues[] = [];
    operatorsSelect.forEach((o) => {
        countriesSelect.sort(sortByName).forEach((c: ICountryWithZone) => {
            const foundItem = defaultList.find((i) => i.operatorId === o.id && i.countryId === c.id);

            const rateItem: IRateCountryFormInitialValues = foundItem
                ? foundItem
                : { id: globalHexId.getId(), operatorId: o.id, countryId: c.id };
            list.push(rateItem);
        });
    });
    const StoreInstance = RateStore.getInstance();

    StoreInstance.setCountriesRateList(list);
}

const makeRateInfo = (data?: IRateItemAPI, included?: IRateIncludeItemAPI[]): IRateInfo => {
    const attributes = data?.attributes && mapApi2UiField(data?.attributes);
    const itemId = data?.id || '';
    const companyId = data?.relationships?.company?.data?.id || '';
    const company =
        (included?.filter((i: IRelationshipItem) => i.type === 'company') as IIncludeNameItemAPI[])?.find(
            (i: IIncludeNameItemAPI) => i.id === companyId,
        )?.attributes?.name || '';

    const currencyId = data?.relationships?.currency?.data?.id || '';
    const currency =
        (included?.filter((i: IRelationshipItem) => i.type === 'currency') as IIncludeItemCurrencyAPI[])?.find(
            (i: IIncludeItemCurrencyAPI) => i.id === currencyId,
        )?.attributes?.abbreviation || '';

    const defaultRateDataUnitId = data?.relationships?.default_rate_data_unit?.data?.id || '';
    const defaultRateDataUnitVal =
        (included?.filter((i: IRelationshipItem) => i.type === 'rate_unit') as IIncludeUnitItemAPI[])?.find(
            (i: IIncludeUnitItemAPI) => i.id === defaultRateDataUnitId,
        )?.attributes?.unit || '';
    const defaultRateDataUnit = getUnitLabel(defaultRateDataUnitVal, currency);

    const defaultRateSmsUnitId = data?.relationships?.default_rate_sms_unit?.data?.id || '';
    const defaultRateSmsUnitVal =
        (included?.filter((i: IRelationshipItem) => i.type === 'rate_unit') as IIncludeUnitItemAPI[])?.find(
            (i: IIncludeUnitItemAPI) => i.id === defaultRateSmsUnitId,
        )?.attributes?.unit || '';
    const defaultRateSmsUnit = getUnitLabel(defaultRateSmsUnitVal, currency);

    const defaultRateVoiceMobileUnitId = data?.relationships?.default_rate_voice_mobile_unit?.data?.id || '';
    const defaultRateVoiceMobileUnitVal =
        (included?.filter((i: IRelationshipItem) => i.type === 'rate_unit') as IIncludeUnitItemAPI[])?.find(
            (i: IIncludeUnitItemAPI) => i.id === defaultRateVoiceMobileUnitId,
        )?.attributes?.unit || '';
    const defaultRateVoiceMobileUnit = getUnitLabel(defaultRateVoiceMobileUnitVal, currency);

    const defaultRateVoiceNetUnitId = data?.relationships?.default_rate_voice_net_unit?.data?.id || '';
    const defaultRateVoiceNetUnitVal =
        (included?.filter((i: IRelationshipItem) => i.type === 'rate_unit') as IIncludeUnitItemAPI[])?.find(
            (i: IIncludeUnitItemAPI) => i.id === defaultRateVoiceNetUnitId,
        )?.attributes?.unit || '';
    const defaultRateVoiceNetUnit = getUnitLabel(defaultRateVoiceNetUnitVal, currency);

    return {
        id: itemId,
        ...attributes,
        companyId,
        company,
        currencyId,
        currency,
        defaultRateDataUnitId,
        defaultRateDataUnit,
        defaultRateSmsUnitId,
        defaultRateSmsUnit,
        defaultRateVoiceMobileUnitId,
        defaultRateVoiceMobileUnit,
        defaultRateVoiceNetUnitId,
        defaultRateVoiceNetUnit,
    };
};

const setRateRateList = (data?: IRateItemAPI, included?: IRateIncludeItemAPI[]) => {
    const rateUnitInclude = included?.filter((i: IRateIncludeItemAPI) => i.type === 'rate_unit') || [];
    const rateCountriesInclude = included?.filter((i: IRateIncludeItemAPI) => i.type === 'sales_rate_list_entry') || [];
    const rateOperatorsInclude = included?.filter((i: IRateIncludeItemAPI) => i.type === 'operator') || [];
    const currencyId = data?.relationships?.currency?.data?.id || '';
    const currency =
        (included?.filter((i: IRelationshipItem) => i.type === 'currency') as IIncludeItemCurrencyAPI[])?.find(
            (i: IIncludeItemCurrencyAPI) => i.id === currencyId,
        )?.attributes?.abbreviation || '';

    const rateCountriesNetworksList: IRateNetworkItem[] =
        data?.relationships?.sales_rate_list_entries?.data?.map((s) => {
            const findRateCountriesInclude = rateCountriesInclude.find((i) => i.id === s.id) as IIncludeRateRateListAPI;

            const findAttributes =
                findRateCountriesInclude?.attributes && mapApi2UiField(findRateCountriesInclude.attributes);

            const countryId = findRateCountriesInclude?.relationships?.country?.data?.id;
            const operatorId = findRateCountriesInclude?.relationships?.operator?.data?.id || appConfig.fakeId;

            const networkId = findRateCountriesInclude?.relationships?.network?.data?.id;
            const networkName =
                (rateOperatorsInclude.find((o) => o.id === networkId) as IItemAPI)?.attributes.name || '';

            const rateDataUnitId = findRateCountriesInclude?.relationships?.rate_data_unit?.data?.id;
            const rateDataUnitVal = (rateUnitInclude.find((r) => r.id === rateDataUnitId) as IIncludeItemUnitAPI)
                ?.attributes.unit;
            const rateDataUnit = rateDataUnitVal ? getUnitLabel(rateDataUnitVal, currency) : rateDataUnitVal;

            const rateSmsUnitId = findRateCountriesInclude?.relationships?.rate_sms_unit?.data?.id;
            const rateSmsUnitVal = (rateUnitInclude.find((r) => r.id === rateSmsUnitId) as IIncludeItemUnitAPI)
                ?.attributes.unit;
            const rateSmsUnit = rateSmsUnitVal ? getUnitLabel(rateSmsUnitVal, currency) : rateSmsUnitVal;

            const rateVoiceMobileUnitId = findRateCountriesInclude?.relationships?.rate_voice_mobile_unit?.data?.id;
            const rateVoiceMobileUnitVal = (
                rateUnitInclude.find((r) => r.id === rateVoiceMobileUnitId) as IIncludeItemUnitAPI
            )?.attributes.unit;
            const rateVoiceMobileUnit = rateVoiceMobileUnitVal
                ? getUnitLabel(rateVoiceMobileUnitVal, currency)
                : rateVoiceMobileUnitVal;

            const rateVoiceNetUnitId = findRateCountriesInclude?.relationships?.rate_voice_net_unit?.data?.id;
            const rateVoiceNetUnitVal = (
                rateUnitInclude.find((r) => r.id === rateVoiceNetUnitId) as IIncludeItemUnitAPI
            )?.attributes.unit;
            const rateVoiceNetUnit = rateVoiceNetUnitVal
                ? getUnitLabel(rateVoiceNetUnitVal, currency)
                : rateVoiceNetUnitVal;

            const rateItem: IRateNetworkItem = {
                id: s.id,
                ...findAttributes,
                countryId,
                operatorId,
                networkId,
                networkName,
                rateDataUnitId,
                rateDataUnit,
                rateSmsUnitId,
                rateSmsUnit,
                rateVoiceMobileUnitId,
                rateVoiceMobileUnit,
                rateVoiceNetUnitId,
                rateVoiceNetUnit,
            };

            return rateItem;
        }) || [];
    const rateCountriesList = rateCountriesNetworksList.filter((i) => !i.networkId);
    createRateList(rateCountriesList);
    setCountriesRateListOriginal(rateCountriesList);
    const rateNetworksList = rateCountriesNetworksList.filter((i) => i.networkId);
    setRateNetworksList(rateNetworksList);
    setRateNetworksListOriginal(rateNetworksList);
};

export function setRateMain(apiResponse: IGetApiResponse) {
    const { resp, isError } = apiResponse;
    if (!isError) {
        setIncludedAssignedCompaniesAPI(resp as IBodyItemResponse);
        const { data, included } = resp as IRateListAPI;
        const info = makeRateInfo(data, included);
        setRateInfo(info);
        setRateRateList(data, included);
    }
}

export async function getRate(id?: string): Promise<boolean> {
    if (!id) {
        createRateInfo();
        return true;
    } else {
        const apiResponse = await apiManager.getApi('GET_SALES_RATE_LIST', { id });
        if (apiResponse.isError) {
            return false;
        } else {
            setRateMain(apiResponse);
            return true;
        }
    }
}

const setRateListStoreV2 = (list: Array<IRateListRespEntryV2>): void => {
    const StoreInstance = RateStore.getInstance();
    StoreInstance.setRateListV2(list);
};

export const addRateListStoreItemV2 = (): string => {
    const newId = globalHexId.getId();
    const newItem: IRateListRespEntryV2 = { id: newId };
    const StoreInstance = RateStore.getInstance();
    const list = StoreInstance.rateListV2;
    list.unshift(newItem);
    setRateListStoreV2(list);
    return newId;
};

export const updateRateListStoreItemV2 = (id: string, item: IRateListRespEntryV2): void => {
    const StoreInstance = RateStore.getInstance();
    const list = StoreInstance.rateListV2;
    const updateList = list.map((i: IRateListRespEntryV2) => (i.id === id ? item : i));
    setRateListStoreV2(updateList);
};

export const deleteRateListStoreItemV2 = (itemId: string): void => {
    const StoreInstance = RateStore.getInstance();
    const list = StoreInstance.rateListV2;
    setRateListStoreV2(list.filter((i: IRateListRespEntryV2) => i.id !== itemId));
};

const mapRateListItemAPI2Store = (item: IRateListRespEntryAPIV2): IRateListRespEntryV2 => {
    const { id, country, network, operator, rate_voice_mobile_unit, rate_voice_net_unit, zone, ...other } = item;
    return {
        id: id.toString(),
        countryId: country?.id?.toString(),
        countryName: country?.name || country?.id?.toString(),
        networkId: network?.id?.toString(),
        networkName: network?.name || network?.id?.toString(),
        operatorId: operator?.id?.toString(),
        operatorName: operator?.name || operator?.id?.toString(),
        rateVoiceMobileUnitId: rate_voice_mobile_unit,
        rateVoiceNetUnitId: rate_voice_net_unit,
        zoneId: zone?.id?.toString(),
        zoneName: zone?.name || zone?.id?.toString(),
        ...mapApi2UiField(other),
    };
};
const mapRateListItemAPI22Store = (item: IRateListRespEntryAPIV22): IRateListRespEntryV2 => {
    const { id, country, network, operator, zone, ...other } = item;
    return {
        id: id.toString(),
        ...mapApi2UiField(other),
        countryId: country?.id?.toString(),
        countryName: country?.name || country?.id?.toString(),
        networkId: network?.id?.toString(),
        networkName: network?.name || network?.id?.toString(),
        operatorId: operator?.id?.toString(),
        operatorName: operator?.name || operator?.id?.toString(),
        zoneId: zone?.id?.toString(),
        zoneName: zone?.name || zone?.id?.toString(),
    };
};

export async function getRateV22(id?: string): Promise<boolean> {
    if (!id) {
        return true;
    } else {
        const apiResponse = await apiManager.getApi('GET_SALES_RATE_LIST_V2', { id });
        if (apiResponse.isError) {
            return false;
        } else {
            const resp = apiResponse.resp as IRateListRespAPIV22;
            const currency =
                resp?.currency?.abbreviation || resp?.currency?.symbol || resp?.currency?.id.toString() || '???';

            const { id: defaultRateDataUnitId, label: defaultRateDataUnit } = getUnitIdLabel({
                unit: resp.default_rate_data_unit,
                currency,
            });
            const { id: defaultRateSmsUnitId, label: defaultRateSmsUnit } = getUnitIdLabel({
                unit: resp.default_rate_sms_unit,
                currency,
            });
            const { id: defaultRateVoiceMobileUnitId, label: defaultRateVoiceMobileUnit } = getUnitIdLabel({
                unit: resp.default_rate_voice_mobile_unit,
                currency,
            });
            const { id: defaultRateVoiceNetUnitId, label: defaultRateVoiceNetUnit } = getUnitIdLabel({
                unit: resp.default_rate_voice_net_unit,
                currency,
            });

            const info: IRateInfo = {
                id,
                name: resp.name,
                notes: optionalAPIString(resp.notes),
                company: resp.company?.name,
                companyId: resp.company?.id?.toString(),
                currency,
                currencyId: resp.currency?.id?.toString(),
                currencySymbol: resp.currency?.symbol,

                calculatedRateData: stringOrUndefined2NumOrUndefined(resp.default_rate_data),
                defaultRateData: stringOrUndefined2NumOrUndefined(resp.default_rate_data),
                defaultRateDataUnit,
                defaultRateDataUnitId,

                calculatedRateSms: stringOrUndefined2NumOrUndefined(resp.default_rate_sms),
                defaultRateSms: stringOrUndefined2NumOrUndefined(resp.default_rate_sms),
                defaultRateSmsUnit,
                defaultRateSmsUnitId,

                calculatedRateVoiceMobile: stringOrUndefined2NumOrUndefined(resp.default_rate_voice_mobile),
                defaultRateVoiceMobile: stringOrUndefined2NumOrUndefined(resp.default_rate_voice_mobile),
                defaultRateVoiceMobileUnit,
                defaultRateVoiceMobileUnitId,

                calculatedRateVoiceNet: stringOrUndefined2NumOrUndefined(resp.default_rate_voice_net),
                defaultRateVoiceNet: stringOrUndefined2NumOrUndefined(resp.default_rate_voice_net),
                defaultRateVoiceNetUnit,
                defaultRateVoiceNetUnitId,
            };
            setRateInfo(info);
            const assignedCompanies: IIncludeAssignedCompanyItem[] =
                resp?.applied_companies?.map((a: IRateListRespAppliedCompanyAPIV22) => ({
                    ...mapApi2UiField(a),
                    id: a.id.toString(),
                    companyId: a.company_id.toString(),
                    company: a.name,
                    startDate: optionalAPIDayjs(a.start_date),
                    endDate: optionalAPIDayjs(a.end_date),
                })) || [];
            setIncludedList('assignedCompanies', assignedCompanies);
            const rateList: Array<IRateListRespEntryV2> =
                resp?.sales_rate_list_entries?.map((i: IRateListRespEntryAPIV22) => mapRateListItemAPI22Store(i)) || [];
            setRateListStoreV2(rateList);
            return true;
        }
    }
}
// export async function getRateV2(id?: string): Promise<boolean> {
//     if (!id) {
//         // createRateInfo();
//         return true;
//     } else {
//         const apiResponse = await apiManager.getApi('GET_SALES_RATE_LIST_V2', { id });
//         if (apiResponse.isError) {
//             return false;
//         } else {
//             const resp = apiResponse.resp as IRateListRespAPIV2;
//             const { id: defaultRateDataUnitId, label: defaultRateDataUnit } = getUnitIdLabel({
//                 unit: resp.default_rate_data_unit,
//                 currency: resp.currency?.abbreviation || resp.currency?.symbol || resp.currency?.id,
//             });
//             const { id: defaultRateSmsUnitId, label: defaultRateSmsUnit } = getUnitIdLabel({
//                 unit: resp.default_rate_sms_unit,
//                 currency: resp.currency?.abbreviation || resp.currency?.symbol || resp.currency?.id,
//             });
//             const { id: defaultRateVoiceMobileUnitId, label: defaultRateVoiceMobileUnit } = getUnitIdLabel({
//                 unit: resp.default_rate_voice_mobile_unit,
//                 currency: resp.currency?.abbreviation || resp.currency?.symbol || resp.currency?.id,
//             });
//             const { id: defaultRateVoiceNetUnitId, label: defaultRateVoiceNetUnit } = getUnitIdLabel({
//                 unit: resp.default_rate_voice_net_unit,
//                 currency: resp.currency?.abbreviation || resp.currency?.symbol || resp.currency?.id,
//             });
//
//             const info: IRateInfo = {
//                 id,
//                 // ...mapApi2UiField(apiResponse.resp),
//                 name: resp.name,
//                 notes: resp.notes,
//                 company: resp.company?.name,
//                 companyId: resp.company?.id?.toString(),
//                 currency: resp.currency?.abbreviation,
//                 currencyId: resp.currency?.id?.toString(),
//                 currencySymbol: resp.currency?.symbol,
//
//                 calculatedRateData: resp.default_rate_data,
//                 defaultRateData: resp.default_rate_data ? +resp.default_rate_data : undefined,
//                 defaultRateDataUnit,
//                 defaultRateDataUnitId,
//
//                 calculatedRateSms: resp.default_rate_sms,
//                 defaultRateSms: resp.default_rate_sms ? +resp.default_rate_sms : undefined,
//                 defaultRateSmsUnit,
//                 defaultRateSmsUnitId,
//
//                 calculatedRateVoiceMobile: resp.default_rate_voice_mobile,
//                 defaultRateVoiceMobile: resp.default_rate_voice_mobile ? +resp.default_rate_voice_mobile : undefined,
//                 defaultRateVoiceMobileUnit,
//                 defaultRateVoiceMobileUnitId,
//
//                 calculatedRateVoiceNet: resp.default_rate_voice_net,
//                 defaultRateVoiceNet: resp.default_rate_voice_net ? +resp.default_rate_voice_net : undefined,
//                 defaultRateVoiceNetUnit,
//                 defaultRateVoiceNetUnitId,
//             };
//             setRateInfo(info);
//             const assignedCompanies: IIncludeAssignedCompanyItem[] =
//                 resp?.applied_companies?.map((a: IRateListRespAppliedCompanyAPIV2) => ({
//                     ...mapApi2UiField(a),
//                     id: a.id.toString(),
//                     companyId: a.company_id.toString(),
//                     company: a.name,
//                     startDate: dayjs(a.start_date),
//                     endDate: dayjs(a.end_date),
//                 })) || [];
//             setIncludedList('assignedCompanies', assignedCompanies);
//             const rateList: Array<IRateListRespEntryV2> =
//                 resp?.sales_rate_list_entries?.map((i: IRateListRespEntryAPIV2) => mapRateListItemAPI2Store(i)) || [];
//             setRateListStoreV2(rateList);
//             return true;
//         }
//     }
// }

export async function deleteRateList(id: string): Promise<void> {
    const { isError } = await apiManager.getApi('DELETE_SALES_RATE_LIST', { id });
    if (!isError) {
        setRatesForcedUpdateTime();
    }
}

export async function getRateShowRelationSelect(): Promise<void> {
    cleanApiMessages();
    await Promise.all([getCountriesWithZoneList(), getZonesSelect(), getOperatorsSelect(true)]);
}

export async function getRateEditRelationSelect(): Promise<void> {
    await Promise.all([
        getRateShowRelationSelect(),
        getCompaniesSelect(true),
        getNetworksSelect(),
        getCurrenciesSelect(),
        getCatalogsRateUnitTypeSelect(),
    ]);
}

export function cleanRateRelationSelect(): void {
    cleanApiMessages();
    cleanZonesStore();
    cleanCountriesStore();
    cleanOperatorsStore();
    cleanCatalogsStore();
    cleanCurrenciesStore();
    cleanIncludedStore();
}

export const updateRateCountryValue = (value: IRateCountryFormInitialValues): void => {
    const StoreInstance = RateStore.getInstance();
    StoreInstance.updateCountryRateValue(value);
};

export const updateRateNetworksValues = (networks: IRateNetworkItem[]): void => {
    if (networks && networks.length) {
        const StoreInstance = RateStore.getInstance();
        let isUpdated = false;
        const newNetworks = StoreInstance.rateNetworksList.map((n: IRateNetworkItem) => {
            const storeNetworkId = n.id;
            const foundFormNetwork = networks.find((f: IRateNetworkItem) => f.id === storeNetworkId);
            if (foundFormNetwork) {
                const updatedStoreNetwork = { ...n, ...foundFormNetwork };
                if (JSON.stringify(updatedStoreNetwork) !== JSON.stringify(n)) {
                    isUpdated = true;
                    return updatedStoreNetwork;
                } else {
                    return n;
                }
            } else {
                return n;
            }
        });
        if (isUpdated) {
            StoreInstance.setRateNetworksList(newNetworks);
        }
    }
};

export function updateCompanyRateForm(form: IRateCountryFormInitialValues): void {
    const StoreInstance = RateStore.getInstance();
    if (form.networks && form.networks.length) {
        const networks = [...form.networks];
        if (networks && networks.length) {
            updateRateNetworksValues(networks);
        }
    }
    const companyRateId = form.id;
    const foundCompanyRate = StoreInstance.rateCountriesList.find((i) => i.id === companyRateId);
    if (foundCompanyRate) {
        delete form.networks;
        const updatedCompanyRate = { ...foundCompanyRate, ...form };
        if (JSON.stringify(updatedCompanyRate) !== JSON.stringify(foundCompanyRate)) {
            updateRateCountryValue(updatedCompanyRate);
        }
    } else {
        console.warn('CompanyRate->', form, 'not found in Store');
    }
}

export function addRateNetworkRateItem(item: IRateNetworkItem): void {
    const StoreInstance = RateStore.getInstance();
    StoreInstance.addNetworkRateItem(item);
}

export const removeRateNetworkValueById = (id: string): void => {
    if (id) {
        const StoreInstance = RateStore.getInstance();
        StoreInstance.removeNetworkById(id);
    }
};

export const sendRateDataInfoV2 = async (isNew: boolean, info: IRateInfo): Promise<IPatchItem> => {
    const StoreInstance = RateStore.getInstance();
    const { rateInfo } = StoreInstance;
    const { id } = rateInfo;
    const body: IRequestRateDataInfo = {
        sales_rate_list: {
            company_id: info.companyId ? +info.companyId : undefined,
            currency_id: info.currencyId ? +info.currencyId : undefined,
            default_rate_data: info.defaultRateData,
            default_rate_data_unit: getUnitById(info.defaultRateDataUnitId),
            default_rate_sms: info.defaultRateSms,
            default_rate_sms_unit: getUnitById(info.defaultRateSmsUnitId),
            default_rate_voice_mobile: info.defaultRateVoiceMobile,
            default_rate_voice_mobile_unit: getUnitById(info.defaultRateVoiceMobileUnitId),
            default_rate_voice_net: info.defaultRateVoiceNet,
            default_rate_voice_net_unit: getUnitById(info.defaultRateVoiceNetUnitId),
            name: info.name,
            notes: info.notes,
        },
    };

    const { resp, isError } = await apiManager.getApi(
        isNew ? 'POST_SALES_RATE_LIST_V2' : 'PUT_SALES_RATE_LIST_V2',
        isNew ? {} : { id },
        body,
    );

    const { errors } = await resp;
    return { isError, errors };
};
export const sendRateData = async (isNew: boolean): Promise<IPatchItem> => {
    const StoreInstance = RateStore.getInstance();
    const { rateInfo, rateCountriesList, rateCountriesListOriginal, rateNetworksList, rateNetworksListOriginal } =
        StoreInstance;
    const { id: rateInfoId, ...rateInfoStore } = rateInfo;
    const rateInfoAPI = mapUi2ApiField(rateInfoStore);
    delete rateInfoAPI.company;
    delete rateInfoAPI.company_id;
    delete rateInfoAPI.currency;
    delete rateInfoAPI.currency_id;
    delete rateInfoAPI.defaultRateDataUnit;
    delete rateInfoAPI.defaultRateSmsUnit;
    delete rateInfoAPI.defaultRateVoiceMobileUnit;
    delete rateInfoAPI.defaultRateVoiceNetUnit;
    delete rateInfoAPI.default_rate_data_unit_id;
    delete rateInfoAPI.default_rate_sms_unit_id;
    delete rateInfoAPI.default_rate_voice_mobile_unit_id;
    delete rateInfoAPI.default_rate_voice_net_unit_id;

    const Relationships = new makeRelationships();
    Relationships.addRelation('company', rateInfo.companyId);
    Relationships.addRelation('currency', rateInfo.currencyId);
    Relationships.addRelation('rate_unit', rateInfo.defaultRateDataUnitId, 'default_rate_data_unit');
    Relationships.addRelation('rate_unit', rateInfo.defaultRateSmsUnitId, 'default_rate_sms_unit');
    Relationships.addRelation('rate_unit', rateInfo.defaultRateVoiceMobileUnitId, 'default_rate_voice_mobile_unit');
    Relationships.addRelation('rate_unit', rateInfo.defaultRateVoiceNetUnitId, 'default_rate_voice_net_unit');

    const { assignedCompanyRelationships, assignedCompanyIncludes } = getIncludeAssignedCompaniesAPI();

    const includedAPI: IRateIncludeItemAPI[] = assignedCompanyIncludes.map(
        (i: IIncludeAssignedCompanyIncludeItemPostAPI) => {
            delete i.attributes?.end_date;
            return i;
        },
    );

    const rateCountryListAPI: IRelationshipItem[] = rateCountriesList
        .filter(
            (i: IRateCountryFormInitialValues) =>
                // !!i.incrementData ||
                !!i.rateData ||
                !!i.rateDataUnitId ||
                !!i.rateSms ||
                !!i.rateSmsUnitId ||
                !!i.rateVoiceMobile ||
                !!i.rateVoiceMobileUnitId ||
                !!i.rateVoiceNet ||
                !!i.rateVoiceNetUnitId,
        )
        .filter((i: IRateCountryFormInitialValues) => {
            if (isNewId(i.id)) {
                return true;
            } else {
                const foundOriginal = rateCountriesListOriginal.find(
                    (o: IRateCountryFormInitialValues) => o.id === i.id,
                );
                if (!foundOriginal) {
                    return true;
                } else {
                    return !equalObjects(foundOriginal, i);
                }
            }
        })
        .map((i: IRateCountryFormInitialValues) => {
            const relation: IRelationshipItem = {
                id: i.id,
                type: 'sales_rate_list_entry',
            };
            const rateUi: IRateCountryFormInitialValues = {
                ...i,
                operatorId: i.operatorId === appConfig.fakeId ? undefined : i.operatorId,
                // incrementData: i.incrementData,
                rateData: i.rateData,
                rateDataUnitId: i.rateDataUnitId,
                rateSms: i.rateSms,
                rateSmsUnitId: i.rateSmsUnitId,
                rateVoiceMobile: i.rateVoiceMobile,
                rateVoiceMobileUnitId: i.rateVoiceMobileUnitId,
                rateVoiceNet: i.rateVoiceNet,
                rateVoiceNetUnitId: i.rateVoiceNetUnitId,
            };

            const rateAPI = mapUi2ApiField(rateUi);
            delete rateAPI.networkName;
            delete rateAPI.rateDataUnit;
            delete rateAPI.rateSmsUnit;
            delete rateAPI.rateVoiceMobileUnit;
            delete rateAPI.rateVoiceNetUnit;
            delete rateAPI.increment_data;
            const included: IIncludeRateRateListAPI = {
                attributes: rateAPI as IIncludeRateAttributesAPI,
                ...relation,
            };

            includedAPI.push(included);

            return relation;
        });

    const rateNetworkRemoveListAPI: IRelationshipItem[] = rateNetworksList
        .filter((i: IRateNetworkItem) => i.destroy)
        .filter((i: IRateNetworkItem) => !isNewId(i.id))
        .map((i: IRateNetworkItem) => ({ id: i.id, type: 'sales_rate_list_entry', destroy: true }));

    const rateNetworkListAPI: IRelationshipItem[] = rateNetworksList
        .filter((i: IRateNetworkItem) => !(i.destroy && !isNewId(i.id)))
        .filter(
            (i: IRateNetworkItem) =>
                // !!i.incrementData ||
                !!i.rateData ||
                !!i.rateDataUnitId ||
                !!i.rateSms ||
                !!i.rateSmsUnitId ||
                !!i.rateVoiceMobile ||
                !!i.rateVoiceMobileUnitId ||
                !!i.rateVoiceNet ||
                !!i.rateVoiceNetUnitId,
        )
        .filter((i: IRateNetworkItem) => {
            if (isNewId(i.id)) {
                return true;
            } else {
                const foundOriginal = rateNetworksListOriginal.find((o: IRateNetworkItem) => o.id === i.id);
                if (!foundOriginal) {
                    return true;
                } else {
                    return !equalObjects(foundOriginal, i);
                }
            }
        })
        .map((i: IRateNetworkItem) => {
            const relation: IRelationshipItem = {
                id: i.id,
                type: 'sales_rate_list_entry',
            };
            const rateUi: IRateCountryFormInitialValues = {
                ...i,
                operatorId: i.operatorId === appConfig.fakeId ? undefined : i.operatorId,
                // incrementData: i.incrementData,
                rateData: i.rateData,
                rateDataUnitId: i.rateDataUnitId,
                rateSms: i.rateSms,
                rateSmsUnitId: i.rateSmsUnitId,
                rateVoiceMobile: i.rateVoiceMobile,
                rateVoiceMobileUnitId: i.rateVoiceMobileUnitId,
                rateVoiceNet: i.rateVoiceNet,
                rateVoiceNetUnitId: i.rateVoiceNetUnitId,
            };
            const rateAPI = mapUi2ApiField(rateUi);
            delete rateAPI.increment_data;
            const included: IIncludeRateRateListAPI = {
                ...relation,
                attributes: rateAPI as IIncludeRateAttributesAPI,
            };
            includedAPI.push(included);

            return relation;
        });

    const body: IRequestAPIBody = {
        data: {
            id: rateInfoId,
            type: 'sales_rate_list',
            attributes: rateInfoAPI,
            relationships: {
                ...Relationships.list(),
                assigned_companies: {
                    data: assignedCompanyRelationships,
                },
                sales_rate_list_entries: {
                    data: [...rateCountryListAPI, ...rateNetworkRemoveListAPI, ...rateNetworkListAPI],
                },
            },
        },
        included: includedAPI,
    };

    const { resp, isError } = await apiManager.getApi(
        isNew ? 'POST_SALES_RATE_LIST' : 'PATCH_SALES_RATE_LIST',
        isNew ? {} : { id: rateInfoId },
        body,
    );
    const { errors } = await resp;
    return { isError, errors };
};

export const setCountryLoadingStats = (newValue: number, paramName: 'expectedToLoad' | 'alreadyLoaded'): void => {
    const StoreInstance = RateStore.getInstance();
    StoreInstance.changeLoadingStats(newValue, paramName);
};

export const addAlreadyLoaded = (): void => {
    const StoreInstance = RateStore.getInstance();
    StoreInstance.addAlreadyLoaded();
};

class makeRelationships {
    private relationships: IRequestRelationships = {};

    public addRelation(type: IIncludeTypeAPI, id?: string, relation?: IIncludeTypeAPI): void {
        if (id) {
            this.relationships[relation || type] = {
                data: {
                    id,
                    type,
                },
            };
        }
    }
    public list(): IRequestRelationships {
        return this.relationships;
    }
}
export function addRateChangedFormTab(tab: RareFormTab): void {
    const StoreInstance = RateStore.getInstance();
    StoreInstance.addChangedFormTab(tab);
}
export function removeRateChangedFormTab(tab: RareFormTab): void {
    const StoreInstance = RateStore.getInstance();
    StoreInstance.removeChangedFormTab(tab);
}

export const saveRateCompanyAssignedV2 = async (
    itemId: string,
    values: IIncludeAssignedCompanyItem,
): Promise<boolean> => {
    const StoreInstance = RateStore.getInstance();
    const { rateInfo } = StoreInstance;
    const { id } = rateInfo;
    const apiValues = {
        company_id: values.companyId,
        start_date: values.startDate?.format(appConfig.formatDate),
    } as IRequestAPIBody;

    const { isError, resp } = await apiManager.getApi(
        isNewId(itemId) ? 'POST_SALES_RATE_LIST_ASSIGNED_COMPANIES_V2' : 'PUT_SALES_RATE_LIST_ASSIGNED_COMPANIES_V2',
        { id, itemId },
        apiValues,
    );

    if (isError) {
        apiMessagesSaveMessagesV2(resp.errors, 'companyId');
    } else {
        removeIncludedList('assignedCompanies', itemId);
        const respItem = resp as IRespSalesRateListAssignedCompany;
        const newACompany: IIncludeAssignedCompanyItem = {
            id: respItem.id.toString(),
            startDate: dayjs(respItem.start_date),
            isActive: respItem.is_active,
            isDeletable: respItem.is_deletable,
            companyId: respItem.company.id.toString(),
            company: respItem.company.name,
        };
        addIncludedList('assignedCompanies', newACompany);
    }

    return !isError;
};
export const deleteRateCompanyAssignedV2 = async (itemId: string): Promise<void> => {
    const StoreInstance = RateStore.getInstance();
    const { rateInfo } = StoreInstance;
    const { id } = rateInfo;
    const { isError } = await apiManager.getApi('DELETE_SALES_RATE_LIST_ASSIGNED_COMPANIES_V2', { id, itemId });
    if (!isError) {
        removeIncludedList('assignedCompanies', itemId);
    }
};
export const deleteRateNewCompanyAssignedV2 = (itemId: string): void => {
    removeIncludedList('assignedCompanies', itemId);
};

export const setRateEditSelectedZoneIdV2 = (id: string | undefined) => {
    const StoreInstance = RateStore.getInstance();
    StoreInstance.setEditSelectedZoneIdV2(id);
};
export const setRateEditSelectedCountryIdV2 = (id: string | undefined) => {
    const StoreInstance = RateStore.getInstance();
    StoreInstance.setEditSelectedCountryIdV2(id);
};

export const saveRateEntriesV2 = async (itemId: string, values: IRateListRespEntryV2): Promise<boolean> => {
    const StoreInstance = RateStore.getInstance();
    const { rateInfo } = StoreInstance;
    const { id } = rateInfo;
    const apiValues = {
        sales_rate_list_entry: {
            operator_id:
                values.operatorId && values.operatorId !== appConfig.fakeId ? Number(values.operatorId) : undefined,
            country_id: values.countryId ? Number(values.countryId) : undefined,
            network_id: values.networkId ? Number(values.networkId) : undefined,
            increment_data: values.incrementData,
            rate_data: values.rateData,
            rate_data_unit: values.rateDataUnitId,
            rate_sms: values.rateSms,
            rate_sms_unit: values.rateSmsUnitId,
            rate_voice_mobile: values.rateVoiceMobile,
            rate_voice_mobile_unit: values.rateVoiceMobileUnitId,
            rate_voice_net: values.rateVoiceNet,
            rate_voice_net_unit: values.rateVoiceNetUnitId,
        },
    } as IRequestAPIBody;

    const { isError, resp } = await apiManager.getApi(
        isNewId(itemId) ? 'POST_SALES_RATE_LIST_ENTRIES_V2' : 'PUT_SALES_RATE_LIST_ENTRIES_V2',
        { id, itemId },
        apiValues,
    );

    if (isError) {
        apiMessagesSaveMessagesV2(resp.errors);
    } else {
        const itemAPI = resp as IRateListRespEntryAPIV2;
        updateRateListStoreItemV2(itemId, mapRateListItemAPI2Store(itemAPI));
    }

    return !isError;
};

export const deleteRateEntriesV2 = async (itemId: string): Promise<void> => {
    const StoreInstance = RateStore.getInstance();
    const { rateInfo } = StoreInstance;
    const { id } = rateInfo;
    const { isError } = await apiManager.getApi('DELETE_SALES_RATE_LIST_ENTRIES_V2', { id, itemId });
    if (!isError) {
        deleteRateListStoreItemV2(itemId);
    }
};
